module.exports = __webpack_public_path__ + "static/media/10-2.de33eee9.mp3";